import React, { useState } from 'react';

export interface WorkspaceWizardProps {
  onComplete: (data: { email: string; key: string }) => void;
  initialConfig?: any;
  ownerPrincipalId?: string;
}

export const WorkspaceWizard: React.FC<WorkspaceWizardProps> = ({ onComplete }) => {
  const [email, setEmail] = useState('');
  const [key, setKey] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onComplete({ email, key });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', background: 'var(--bg-surface, #0f172a)', color: 'var(--text-primary, #f8fafc)', padding: '24px' }}>
      <div style={{ background: 'var(--bg-card, #1e293b)', border: '1px solid var(--border-color, #334155)', borderRadius: '12px', padding: '32px', width: '100%', maxWidth: '420px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.3)' }}>
        <h2 style={{ marginBottom: '8px', fontSize: '20px', fontWeight: '600' }}>Sovereign Mesh Activation</h2>
        <p style={{ color: 'var(--text-muted, #94a3b8)', fontSize: '14px', marginBottom: '24px' }}>Enter your administrator email and activation key to provision your node.</p>
        
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', marginBottom: '6px', fontWeight: '500' }}>Administrator Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              placeholder="admin@sovereign.mesh" 
              required
              style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid var(--border-color, #334155)', background: 'rgba(255,255,255,0.03)', color: '#fff', fontSize: '14px' }}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '13px', marginBottom: '6px', fontWeight: '500' }}>Activation Code / Secret Key</label>
            <input 
              type="password" 
              value={key} 
              onChange={e => setKey(e.target.value)} 
              placeholder="••••••••••••••••" 
              required
              style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid var(--border-color, #334155)', background: 'rgba(255,255,255,0.03)', color: '#fff', fontSize: '14px' }}
            />
          </div>
          <button 
            type="submit"
            style={{ marginTop: '8px', padding: '12px', borderRadius: '6px', background: 'var(--accent-blue, #3b82f6)', color: '#fff', fontWeight: '600', border: 'none', cursor: 'pointer', fontSize: '14px' }}
          >
            Activate Node & Enter Dashboard
          </button>
        </form>
      </div>
    </div>
  );
};
